
import { useEffect } from "react";
import { useState } from "react";
import { SubscribeEmail } from "../../Store/Api/ApiCall";
import Fonts from "../../Customs/Fonts";
import {
  Block,
  Button,
  Card_img,
  Flex_Con,
  DescriptionText,
  HeaderTextLighter,
  InputField,
  FadeOutBox,
  ErrorText,
} from "../../component/styledComponent";
import Resource from "../../Resources/Resource";
import { SubmitUX } from "./Footer";
import { Validate } from "./validateForm";

const EmailForm = () => {

  const [submitFlag, setSubmitFlag] = useState(false);
  const [name, setName] = useState("");
  const [Error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [RequestToggle, setRequestToggle] = useState(true);
  
  function Reset() {
    setError("");
    setName("");
    setEmail("");
    setAddress("");
    submitFlag(false);
  }

  const handleSubmit = () => {
    let data = {
      name: name,
      email: email,
    };

    Validate(data).then((res) => {
      console.log(res.message);
      if (res) {
        setError(res.message);
      } else {
        setError(null);
        SubscribeEmail(data, RequestToggle).then((res) => {
          console.log(res);

          if (res.value) {
            setSubmitFlag(!submitFlag);

            setTimeout(() => {
              console.log("hello");
              setSubmitFlag(false);
            }, 5000);

            Reset();
          }
        });
      }
    });
  };

  useEffect(() => {
    console.log("Flag changed:", submitFlag);
  }, [submitFlag]);
  return (
    <>
      <Flex_Con
        style={{
          justifyContent: "center",
          alignContent: "center",
          maxWidth: "1100px",
          margin: "0 auto",
          alignItems: "center",
          padding: "100px 0 ",
        }}
      >
        <Block>
          <Block style={{ width: "100%" }}>
            <Card_img src={Resource.DoubleCards.Location} />{" "}
          </Block>
        </Block>

        <Block
          pad="25px"
          style={{
            backgroundColor: "white",
            color: "black",
            borderRadius: "7px",
          }}
        >
          {submitFlag && (
            <>
              {" "}
              <FadeOutBox>
                <Block
                  style={{
                    position: "absolute",
                  }}
                >
                  <SubmitUX></SubmitUX>
                </Block>
              </FadeOutBox>
            </>
          )}

          {FormText()}
          <Block>
            <form onSubmit={handleSubmit}>
              {Name(name, setName)}
              {Email(email, setEmail)}
              {Eth_address(address, setAddress)}
              {Error ? <ErrorText>{Error}</ErrorText> : ""}
              <Block style={{ margin: "20px 0 " }}>
                <Button
                  placeholder="Submit"
                  type="submit"
                  onClick={handleSubmit}
                  style={{ padding: "10px 110px" }}
                >
                  Submit
                </Button>
                {/* <Switch
              checked={checked}
              onChange={UrlToggle}
              defaultChecked
              color="secondary"
            /> */}
              </Block>
            </form>
            {/* {Submit()} */}
          </Block>
        </Block>
      </Flex_Con>
    </>
  );
};
const FormText = () => {
  return (
    <>
      <Block maxW="300px">
        <HeaderTextLighter font={Fonts.jetBrains} size="40px" weight="800">
          {" "}
          Join the WaitList
        </HeaderTextLighter>
        <DescriptionText>
          Join WaitList and get updates from <b>X-PASS</b> straight to your
          Inbox.
        </DescriptionText>
      </Block>
    </>
  );
};

const Name = (name, setName) => {
  return (
    <>
      <Block>
        <InputField
          placeholder="Name"
          value={name}
          onChange={(v) => setName(v.target.value)}
        ></InputField>
      </Block>
    </>
  );
};
const Email = (email, setEmail) => {
  return (
    <>
      <Block>
        <InputField
          placeholder="Email"
          value={email}
          onChange={(v) => setEmail(v.target.value)}
        ></InputField>
      </Block>
    </>
  );
};
const Eth_address = (address, setAddress) => {
  return (
    <>
      <Block>
        <InputField
          placeholder="Ethereum Address (optional)"
          value={address}
          onChange={(v) => setAddress(v.target.value)}
        ></InputField>
      </Block>
    </>
  );
};

export default EmailForm;
